import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_333: DocMigration = {
  maxSchemaVersion: "0.0.333",
  description:
    "Update font size for text that has a font size defined. This fits the font size that was originally specified fairly well.",
  apply(json: any) {
    const FONT_SIZE_SCALE_FACTOR = 9 / 16;

    for (const annoId in json.annotation) {
      const anno = json.annotation[annoId];
      if (typeof anno.fontSize === "number") {
        anno.fontSize *= FONT_SIZE_SCALE_FACTOR;
      }
    }
    for (const tableId in json.dataTables) {
      const table = json.dataTables[tableId];
      if (typeof table.fontSize === "number") {
        table.fontSize *= FONT_SIZE_SCALE_FACTOR;
      }
    }
    return json;
  },
};

export default migration_0_0_333;
